// extracted by css-extract-rspack-plugin
export default {"pageLayout":"src-app-pages-electronic-document-IncompleteBox-IncompleteBox-module__pageLayout-mctnGq","headerTable":"src-app-pages-electronic-document-IncompleteBox-IncompleteBox-module__headerTable-M3CnUa"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"pageLayout\":\"src-app-pages-electronic-document-IncompleteBox-IncompleteBox-module__pageLayout-mctnGq\",\"headerTable\":\"src-app-pages-electronic-document-IncompleteBox-IncompleteBox-module__headerTable-M3CnUa\"}";
        // 1789362522827
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  